import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router";
import { UrlPath } from "../../../config/routeConfig";
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsMenuList } from "../../actions/assetTransactionsAction";

export const HoverList = ({ isHovered, handleListMouseEnter, handleListMouseLeave }) => {
  const history = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const Gstate =
  useSelector((state) => {
    return state;
  }) || {};
  const TransactionMenuList = Gstate.transactionList.transactionMenuList || [];
  useEffect(() => {
    if(isHovered === true)
    dispatch(getTransactionsMenuList(params.AssetId));
  },[isHovered]);

  const handleItemClick = (item) => {
    if(item.TransTypeId!=5 && item.IsVisible)
    {
      const transType=item?.DisplayName?.replace(/\s/g, '');
      history(`${UrlPath.Transactions}${transType}/0/${params.AssetId}/${1}`);
    }
  };
  return (
    isHovered && (
      <div className="list-of-items" onMouseEnter={handleListMouseEnter} onMouseLeave={handleListMouseLeave}>
        {TransactionMenuList.map((item) => (
          <div
            key={item.DisplayName}
            onClick={() =>  handleItemClick(item)}
            className={(!item.IsVisible || item.TransTypeId==5) ? "disabled-menu-item" : "" }
          >
            {item.DisplayName}
          </div>
        ))}
      </div>
    )
  );
};

